// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
// component
import { NewChatModal } from './new-chat-modal'

const COMPONENT_ID = 'newChat'

export const showCreateNewChatModal = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: NewChatModal,
  },
}
